/** Rating value sent for positive (thumb up) feedback */
export const HMD_POSITIVE_RATING = '10';

/** Rating value sent for negative (thumb down) feedback */
export const HMD_NEGATIVE_RATING = '1';

/** Thumb direction value for positive feedback */
export const HMD_THUMB_UP = 'up';

/** Thumb direction value for negative feedback */
export const HMD_THUMB_DOWN = 'down';
